import React from 'react'
import { Link } from 'gatsby'
import { Hit } from 'react-instantsearch-core'
import RightArrow from '@/assets/icons/right-arrow.svg'
import { PageHitText } from '../PageHitText/PageHitText'

export const HelpPageHit: React.ComponentType<{ hit: Hit; query?: string }> = ({ hit, query }) => (
  <div className="flex flex-col justify-between m-16 mb-40 tablet:mb-64">
    {hit.slug && (
      <Link to={`${hit.slug}`}>
        <h4 className="text-bodyL laptop:text-headingL-mobile font-bold text-text-dark-900 mb-24 text-red">
          <PageHitText attribute="title" hit={hit} highlightProperty="_highlightResult" />
        </h4>
      </Link>
    )}
    {!hit.slug && hit.url && (
      <a href={hit.url}>
        <h4 className="text-bodyL laptop:text-headingL-mobile font-bold text-text-dark-900 mb-24">
          <PageHitText attribute="title" hit={hit} highlightProperty="_highlightResult" />
        </h4>
      </a>
    )}
    <PageHitText attribute="description" hit={hit} highlightProperty="_snippetResult" />
    <PageHitText attribute="sections[0].description" hit={hit} highlightProperty="_snippetResult" />
    <Link to={`${hit.slug}?keyword=${query}`}>
      <p>
        <PageHitText attribute="content" hit={hit} highlightProperty="_snippetResult" />
      </p>
    </Link>

    <div className="flex mt-5">
      {hit.slug ? (
        <Link to={`${hit.slug}`} className="text-bodyL text-primary-500 font-bold">
          Visit page
        </Link>
      ) : (
        <a href={hit.url} className="text-bodyL text-primary-500 font-bold">
          Visit page
        </a>
      )}
      <img src={RightArrow} className="w-16 ml-10" alt="visit-page" />
    </div>
  </div>
)
